<template>
  <div class="container">
    <nav class="navbar">
      <ul>
        <li><a href="/pages/aboutIntroduction.html?article_id=59" target="_blank" class="item">联系我们</a></li>
        <li><a href="/pages/aboutIntroduction.html?article_id=15" target="_blank" class="item">关于我们</a></li>
        <li><a href="/pages/noteList.html?c_id=8" target="_blank" class="item">数据介绍</a></li>
        <li><a href="/pages/aboutIntroduction.html?article_id=16" target="_blank" class="item">免责申明</a></li>
        <li><a href="/pages/dataOpen.html" target="_blank" class="item">数据开放</a></li>
        <li><a href="/pages/correct.html" target="_blank" class="item">数据纠错</a></li>
      </ul>
    </nav>
    <div class="copyright">&copy;&nbsp;2013 - 2023&nbsp;绿网环境保护服务中心版权所有，并保留所有权利&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/">粤ICP备15063264号-1</a></div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang='scss' scoped>
.container {
  max-width: unset;
  background-color: #4A4A4A;
  color: #FFFFFF;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  a {
    color: #FFFFFF;
    text-decoration: none;
  }

  .navbar {
    margin-bottom: 10px;
    ul {
      list-style-type: none;
      padding-left: 0;
      margin-block-start: 0;
      margin-block-end: 0;
      padding-inline-start: 0;
      li {
        display: inline-block;
        a {
          display: inline-block;
          border-right: 1px solid #FFFFFF;
          padding: 0 5px;
        }
        &:last-of-type a {
          border-right: unset;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue